import { useEntitlements } from '~/hooks/account';

export const useCRMLabel = () => {
  const { hasAccessSettingsConnectedServices } = useEntitlements();

  const crmLabel = hasAccessSettingsConnectedServices ? 'HubSpot' : 'your CRM';

  return { crmLabel };
};
